import { useState, useEffect } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Typography,
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  CircularProgress,
  Button,
  TextField
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
// import * as XLSX from 'xlsx-js-style';
import { fetchData } from '../../../apiService';
import { useAuth } from '../../../AuthContext';

const ForecastModal = ({
  open,
  onClose,
  itemData = null,
  toDate = ''
}) => {
  const { companyId, token } = useAuth();
  const [loading, setLoading] = useState(false);
  const [forecastData, setForecastData] = useState([]);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 600);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 600);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    if (open && itemData && itemData.ItemId) {
      fetchForecastData();
    }
  }, [open, itemData, toDate]);

  const fetchForecastData = async () => {
    setLoading(true);
    try {
      const params = `/Forecast/${toDate}/${companyId}/${itemData.ItemId}`;
      const response = await fetchData('ReportApi', params, token);
      
      if (response && response.responseCode === '1111' && response.response_data) {
        setForecastData(response.response_data);
      } else {
        setForecastData([]);
      }
    } catch (error) {
      console.error('Error fetching forecast data:', error);
      setForecastData([]);
    } finally {
      setLoading(false);
    }
  };

  const calculateTotal = () => {
    return forecastData.reduce((sum, row) => sum + (parseFloat(row.ForecastQty) || 0), 0);
  };

  const exportToExcel = () => {
    // const exportData = forecastData.map(row => ({
    //   'Forecast Qty': row.ForecastQty || 0,
    //   'Forecast Date': row.ForecastDate || '',
    //   'Expected Return Date': row.ExpectedReturnDate || '',
    //   'Expected Return Time': row.ExpectedReturnTime || ''
    // }));

    // // Add total row
    // exportData.push({
    //   'Forecast Qty': calculateTotal(),
    //   'Forecast Date': 'TOTAL',
    //   'Expected Return Date': '',
    //   'Expected Return Time': ''
    // });

    // // Create worksheet
    // const worksheet = XLSX.utils.json_to_sheet(exportData);

    // // Set column widths
    // worksheet['!cols'] = [
    //   { wch: 15 },
    //   { wch: 20 },
    //   { wch: 25 },
    //   { wch: 25 }
    // ];

    // // Get the range of the worksheet
    // const range = XLSX.utils.decode_range(worksheet['!ref']);
    
    // // Style header row (row 0)
    // for (let col = range.s.c; col <= range.e.c; col++) {
    //   const cellAddress = XLSX.utils.encode_cell({ r: 0, c: col });
    //   if (!worksheet[cellAddress]) continue;
      
    //   worksheet[cellAddress].s = {
    //     fill: {
    //       fgColor: { rgb: "667eea" }  // Purple gradient color
    //     },
    //     font: {
    //       bold: true,
    //       color: { rgb: "FFFFFF" },
    //       sz: 12,
    //       name: "Arial"
    //     },
    //     alignment: {
    //       horizontal: "center",
    //       vertical: "center"
    //     },
    //     border: {
    //       top: { style: "thin", color: { rgb: "000000" } },
    //       bottom: { style: "thin", color: { rgb: "000000" } },
    //       left: { style: "thin", color: { rgb: "000000" } },
    //       right: { style: "thin", color: { rgb: "000000" } }
    //     }
    //   };
    // }

    // // Style data rows with alternating colors
    // for (let row = range.s.r + 1; row <= range.e.r - 1; row++) {
    //   for (let col = range.s.c; col <= range.e.c; col++) {
    //     const cellAddress = XLSX.utils.encode_cell({ r: row, c: col });
    //     if (!worksheet[cellAddress]) continue;
        
    //     const isEvenRow = (row - 1) % 2 === 0;
        
    //     worksheet[cellAddress].s = {
    //       fill: {
    //         fgColor: { rgb: isEvenRow ? "FFFFFF" : "F8F9FA" }
    //       },
    //       font: {
    //         sz: 11,
    //         name: "Arial",
    //         color: { rgb: "2d3748" }
    //       },
    //       alignment: {
    //         horizontal: col === 0 ? "right" : "left",
    //         vertical: "center"
    //       },
    //       border: {
    //         top: { style: "thin", color: { rgb: "E9ECEF" } },
    //         bottom: { style: "thin", color: { rgb: "E9ECEF" } },
    //         left: { style: "thin", color: { rgb: "E9ECEF" } },
    //         right: { style: "thin", color: { rgb: "E9ECEF" } }
    //       }
    //     };

    //     // Format numbers with thousand separators
    //     if (col === 0 && worksheet[cellAddress].v !== '') {
    //       worksheet[cellAddress].z = '#,##0';
    //     }
    //   }
    // }

    // // Style total row (last row)
    // const totalRow = range.e.r;
    // for (let col = range.s.c; col <= range.e.c; col++) {
    //   const cellAddress = XLSX.utils.encode_cell({ r: totalRow, c: col });
    //   if (!worksheet[cellAddress]) continue;
      
    //   worksheet[cellAddress].s = {
    //     fill: {
    //       fgColor: { rgb: "667eea" }  // Purple gradient color
    //     },
    //     font: {
    //       bold: true,
    //       color: { rgb: "FFFFFF" },
    //       sz: 12,
    //       name: "Arial"
    //     },
    //     alignment: {
    //       horizontal: col === 0 ? "right" : "left",
    //       vertical: "center"
    //     },
    //     border: {
    //       top: { style: "medium", color: { rgb: "764ba2" } },
    //       bottom: { style: "medium", color: { rgb: "764ba2" } },
    //       left: { style: "thin", color: { rgb: "000000" } },
    //       right: { style: "thin", color: { rgb: "000000" } }
    //     }
    //   };

    //   // Format numbers in total row
    //   if (col === 0 && worksheet[cellAddress].v !== '') {
    //     worksheet[cellAddress].z = '#,##0';
    //   }
    // }

    // // Set row heights
    // worksheet['!rows'] = [];
    // for (let row = range.s.r; row <= range.e.r; row++) {
    //   worksheet['!rows'][row] = { hpt: row === 0 || row === totalRow ? 25 : 20 };
    // }

    // const workbook = XLSX.utils.book_new();
    // XLSX.utils.book_append_sheet(workbook, worksheet, 'Forecast Report');
    
    // // Add workbook properties
    // workbook.Props = {
    //   Title: "Forecast Report",
    //   Subject: `Forecast Report - ${itemData?.Name || 'Item'}`,
    //   Author: "EFFTABS SOLUTIONS LLP",
    //   CreatedDate: new Date()
    // };
    
    // const fileName = `Forecast_${itemData?.Name || 'Item'}_${new Date().toISOString().split('T')[0]}.xlsx`;
    // XLSX.writeFile(workbook, fileName, { cellStyles: true });
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="md"
      fullWidth
      fullScreen={isMobile}
      PaperProps={{
        style: {
          borderRadius: isMobile ? '0' : '12px',
          background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
          padding: '2px',
          margin: isMobile ? '0' : '8px'
        }
      }}
    >
      <Box style={{
        background: 'white',
        borderRadius: isMobile ? '0' : '10px',
        overflow: 'hidden',
        height: isMobile ? '100vh' : 'auto'
      }}>
        <DialogTitle style={{
          background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
          color: 'white',
          padding: '6px 10px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          minHeight: 'auto'
        }}>
          <Box style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
            <TrendingUpIcon style={{ fontSize: '16px' }} />
            <Typography variant="h6" style={{ fontWeight: '600', fontSize: '13px' }}>
              Forecast - {itemData?.Name || 'Item'}
            </Typography>
          </Box>
          <Box style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
            {forecastData.length > 0 && (
              <Button
                onClick={exportToExcel}
                size="small"
                startIcon={<FileDownloadIcon style={{ fontSize: '14px' }} />}
                style={{
                  color: 'white',
                  textTransform: 'none',
                  fontSize: '11px',
                  padding: '2px 8px',
                  minWidth: 'auto'
                }}
              >
                Export
              </Button>
            )}
            <IconButton
              onClick={onClose}
              style={{ color: 'white', padding: '2px' }}
              size="small"
            >
              <CloseIcon style={{ fontSize: '16px' }} />
            </IconButton>
          </Box>
        </DialogTitle>

        <DialogContent style={{
          padding: '8px',
          minHeight: '200px'
        }}>
          {loading ? (
            <Box style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              minHeight: '300px'
            }}>
              <CircularProgress style={{ color: '#667eea' }} />
            </Box>
          ) : forecastData.length > 0 ? (
            <>
              {/* Item Summary - Single Line */}
              <Box style={{
                marginBottom: '8px',
                padding: '6px 10px',
                background: '#f8f9fa',
                borderRadius: '6px',
                border: '1px solid #e9ecef',
                display: 'flex',
                alignItems: 'center',
                gap: '20px',
                flexWrap: 'wrap'
              }}>
                <Box style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                  <Typography style={{ fontSize: '10px', color: '#666' }}>
                    Total Stock:
                  </Typography>
                  <Typography style={{ fontSize: '12px', fontWeight: '600', color: '#2d3748' }}>
                    {forecastData[0]?.TotalStock || 0}
                  </Typography>
                </Box>
                <Box style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                  <Typography style={{ fontSize: '10px', color: '#666' }}>
                    On Rent:
                  </Typography>
                  <Typography style={{ fontSize: '12px', fontWeight: '600', color: '#f59e0b' }}>
                    {forecastData[0]?.CurrentlyOnRentQty || 0}
                  </Typography>
                </Box>
                <Box style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                  <Typography style={{ fontSize: '10px', color: '#666' }}>
                    Total Forecast:
                  </Typography>
                  <Typography style={{ fontSize: '12px', fontWeight: '600', color: '#667eea' }}>
                    {calculateTotal()}
                  </Typography>
                </Box>
              </Box>

              {/* Forecast Details Table */}
              <TableContainer component={Paper} style={{
                boxShadow: '0 1px 4px rgba(0, 0, 0, 0.06)',
                borderRadius: '6px',
                overflow: 'hidden'
              }}>
                <Table size="small">
                  <TableHead>
                    <TableRow style={{
                      background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)'
                    }}>
                      <TableCell align="right" style={{
                        color: 'white',
                        fontWeight: '600',
                        fontSize: '10px',
                        textTransform: 'uppercase',
                        padding: '4px 8px'
                      }}>
                        Qty
                      </TableCell>
                      <TableCell style={{
                        color: 'white',
                        fontWeight: '600',
                        fontSize: '10px',
                        textTransform: 'uppercase',
                        padding: '4px 8px'
                      }}>
                        Forecast Date
                      </TableCell>
                      <TableCell style={{
                        color: 'white',
                        fontWeight: '600',
                        fontSize: '10px',
                        textTransform: 'uppercase',
                        padding: '4px 8px'
                      }}>
                        Return Date
                      </TableCell>
                      <TableCell style={{
                        color: 'white',
                        fontWeight: '600',
                        fontSize: '10px',
                        textTransform: 'uppercase',
                        padding: '4px 8px'
                      }}>
                        Return Time
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {forecastData.map((row, index) => (
                      <TableRow key={index} style={{
                        background: index % 2 === 0 ? '#ffffff' : '#f8f9fa',
                        borderBottom: '1px solid #e9ecef'
                      }}>
                        <TableCell align="right" style={{
                          fontSize: '11px',
                          padding: '4px 8px',
                          color: '#2d3748',
                          fontWeight: '600'
                        }}>
                          {row.ForecastQty || 0}
                        </TableCell>
                        <TableCell style={{
                          fontSize: '11px',
                          padding: '4px 8px',
                          color: '#2d3748'
                        }}>
                          {row.ForecastDate}
                        </TableCell>
                        <TableCell style={{
                          fontSize: '11px',
                          padding: '4px 8px',
                          color: '#2d3748'
                        }}>
                          {row.ExpectedReturnDate}
                        </TableCell>
                        <TableCell style={{
                          fontSize: '11px',
                          padding: '4px 8px',
                          color: '#2d3748'
                        }}>
                          {row.ExpectedReturnTime}
                        </TableCell>
                      </TableRow>
                    ))}
                    {/* Total Row */}
                    <TableRow style={{
                      background: '#667eea',
                      borderTop: '2px solid #764ba2'
                    }}>
                      <TableCell align="right" style={{
                        fontSize: '11px',
                        padding: '4px 8px',
                        color: 'white',
                        fontWeight: '700'
                      }}>
                        {calculateTotal()}
                      </TableCell>
                      <TableCell colSpan={3} style={{
                        fontSize: '11px',
                        padding: '4px 8px',
                        color: 'white',
                        fontWeight: '700'
                      }}>
                        TOTAL
                      </TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </TableContainer>
            </>
          ) : (
            <Box style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              minHeight: '300px',
              color: '#666',
              fontSize: '14px'
            }}>
              No forecast data available for this item.
            </Box>
          )}
        </DialogContent>
      </Box>
    </Dialog>
  );
};

export default ForecastModal;
